import React, { FunctionComponent, useState } from 'react'
import { FaTwitter } from 'react-icons/fa'
import Dialog from '@material-ui/core/Dialog'
import moment from 'moment'

import '../styles/Item.scss'
import { TweetData } from '../utils/SearchItem'
import Icon from './Icon'
import MatchingTerms from './MatchingTerms'

const TweetItem: FunctionComponent<TweetData> = (props) => {
  const [open, toggleOpen] = useState(false)

  const renderPopup = () => {
    const date = moment(new Date(props.timestamp)).format(
      'h:mm A • MMM D, YYYY'
    )
    return (
      <Dialog open={open} onClose={() => toggleOpen(false)}>
        <div className='Item-popup'>
          <div className='Item-popup-header'>
            <Icon icon={FaTwitter} backgroundColor='#d8dbef' />
            <p>{props.message}</p>
          </div>
          <div className='Item-popup-content'>
            <strong>
              <p>User: </p>
            </strong>
            <p>{props.user}</p>
            <strong>
              <p>Full Tweet: </p>
            </strong>
            <p>"{props.message}"</p>
            <strong>
              <p>Timestamp: </p>
            </strong>
            <p>{date}</p>
          </div>
          <MatchingTerms
            backgroundColor='#d8dbef'
            terms={props.matching_terms}
          />
        </div>
      </Dialog>
    )
  }

  return (
    <>
      <div className='Item' onClick={() => toggleOpen(true)}>
        <Icon icon={FaTwitter} backgroundColor='#d8dbef' />
        <p>{props.message}</p>
      </div>
      {renderPopup()}
    </>
  )
}

export default TweetItem
